import { Store } from '@/types/store';
import { atom } from 'jotai';

export const storeAtom = atom<Store>(Store.FR);
